const e = {
  /** equivalent to  414px */
  xsm: "25.875em",
  /** equivalent to 650px */
  sm: "40.625em",
  /** equivalent to 900px */
  md: "56.25em",
  /**  equivalent to 1024px */
  lg: "64em",
  /** equivalent to 1376px */
  xl: "86em"
};
export {
  e as default
};
